import SearchBox from './SearchBox';
import { connect } from 'react-redux';

const mapStateToProps = ({ renderOptions: { showStabSearchbox }}) => ({
  showStabSearchbox
});

export default connect(mapStateToProps, null)(SearchBox);




// WEBPACK FOOTER //
// ./src/universal/components/SearchBox/index.js